// README: 类似枚举，公共数据的接口放这里
// import { service } from '@/ajax/request'
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { service } from '@/ajax/request';

import dayjs from 'dayjs';
import config from "@/config/default";

export const getRegionList = () => {
    const timestamp = dayjs().valueOf();
    return axios({
        url: `${config.uploadImgUrl}system_info/area.json?time=${timestamp}`,
        method: 'GET',
    })
}

export const getCountryCodeList = () => {
    const timestamp = dayjs().valueOf();
    return axios({
        url: `${config.uploadImgUrl}system_info/areaList.json?timeStamp=${timestamp}`,
        method: 'GET',
    })
}


export const getAllStore = (params = { storeName: "" }) => (
    service({
        url: '/store/storeDevice/get-all-store',
        method: 'POST',
        params,
    })
)